export const cmdImport = 'gjs-open-import-webpage';
export const cmdClear = 'canvas-clear';
import { EXTRA_TEASER_FIELD_OPTIONS } from './blocks/TeaserBlocks/consts/extraFields';
import { HIDDEN_TEASER_FIELDS } from './blocks/TeaserBlocks/consts/hiddenFields';
import { EXTRA_JOURNEY_DETAIL_FIELD_OPTIONS } from './blocks/JourneyDetailBlocks/consts/extraFields';
import { HIDDEN_JOURNEY_DETAIL_FIELDS } from './blocks/JourneyDetailBlocks/consts/hiddenFields';

export const DYNAMIC_FIELD_CONFIG = {
    teaser: {
        modelKeys: ['tourism/itinerary'],
        extraFields: EXTRA_TEASER_FIELD_OPTIONS,
        hiddenFields: HIDDEN_TEASER_FIELDS,
    },
    journeyDetail: {
        modelKeys: ['tourism/itinerary'],
        extraFields: EXTRA_JOURNEY_DETAIL_FIELD_OPTIONS,
        hiddenFields: HIDDEN_JOURNEY_DETAIL_FIELDS,
    },
    intentBlock: {
        modelKeys: [''],
        extraFields: [],
        hiddenFields: [],
    },
};
